import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initState, AuditLogsData, AuditLogs } from './types';

const initialState: initState = {
  list: {
    data: [
      {
        id: 0,
        entityType: '',
        entityId: 0,
        action: '',
        actorType: '',
        actorId: 0,
        actorMetadata: {},
        changes: {},
        createdAt: '',
      },
    ],
    pagination: {
      total: 0,
      limit: 0,
      page: 0,
      totalPages: 0,
    },
  },
  audits: [],
};

const auditLogsSlice = createSlice({
  name: 'auditLogs',
  initialState,
  reducers: {
    setAuditLogsData(state: initState, action: PayloadAction<{ list: AuditLogsData }>) {
      state.list = action.payload.list;
    },
    setAudits(state: initState, action: PayloadAction<AuditLogs[]>) {
      state.audits = action.payload;
    },
  },
});

export const { setAuditLogsData, setAudits } = auditLogsSlice.actions;

export default auditLogsSlice.reducer;
